import { Input, type InputProps, Spinner } from '@cosuno/cosuno-ui';
import { type ComponentProps, type FC, type FocusEvent, useCallback } from 'react';

import { generateField } from '~/shared/components/Field/generateField';

import { useEmailValidator } from './useEmailValidator';

const BaseEmailInputField = generateField<InputProps>(Input);

export type EmailFieldProps = Omit<
  ComponentProps<typeof BaseEmailInputField>,
  'validate' | 'suffixLabel'
> & {
  validateDomain?: boolean;
};

export const EmailField: FC<EmailFieldProps> = (props) => {
  const { onBlur, validateDomain: isValidationEnabled, error, ...inputProps } = props;
  const {
    validateFormat,
    validateDomain,
    error: validateError,
    isValidating,
  } = useEmailValidator();

  const handleBlur = useCallback(
    (event: FocusEvent) => {
      if (isValidationEnabled && 'value' in event.target) {
        void validateDomain(event.target.value);
      }
      onBlur?.(event);
    },
    [isValidationEnabled, validateDomain, onBlur],
  );

  return (
    <BaseEmailInputField
      {...inputProps}
      validate={validateFormat}
      onBlur={handleBlur}
      error={error ?? validateError}
      suffixLabel={isValidating && <Spinner />}
    />
  );
};
